import React from 'react';
import { motion } from 'framer-motion';
import { EbookMockup } from './EbookMockup';
export const Hero = () => {
  return <section className="pt-32 pb-16 sm:pt-40 sm:pb-24 px-4 overflow-hidden bg-brand-light" data-id="element-62">
      <div className="max-w-7xl mx-auto" data-id="element-63">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-64">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-65">
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-brand-dark leading-[1.1] mb-6" data-id="element-66">
              How to Secure Your $150k+ Salary, Outperform 99% of Your
              Colleagues, and Become{' '}
              <span className="text-brand-accent" data-id="element-67">"AI-Unreplaceable"</span> in
              Less Than 30 Days.
            </h1>

            <p className="text-lg sm:text-xl text-brand-dark/80 font-medium mb-6" data-id="element-68">
              — Even if you've never used ChatGPT and think you're "not a tech
              person."
            </p>

            <p className="text-base sm:text-lg text-brand-dark/70 mb-10 leading-relaxed" data-id="element-69">
              Stop waking up with the "Automation Anxiety." Master the tactical
              AI frameworks that top-tier executives at Google and McKinsey are
              using to regain 15+ hours a week and double their professional
              value.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 mb-12" data-id="element-70">
              <a href="#get-access" className="w-full sm:w-auto bg-brand-accent text-white font-bold text-lg px-8 py-4 rounded-sm hover:bg-brand-accent/90 transition-all transform hover:scale-105 shadow-lg shadow-brand-accent/20 text-center flex items-center justify-center gap-3" data-id="element-71">
                YES! I WANT TO BECOME UNREPLACEABLE
              </a>
              <div className="flex items-center gap-3 text-lg font-bold" data-id="element-72">
                <span className="text-brand-dark/40 line-through decoration-2" data-id="element-73">
                  $497
                </span>
                <span className="text-brand-dark text-2xl" data-id="element-74">$47</span>
              </div>
            </div>

            <div className="pt-8 border-t border-brand-dark/10" data-id="element-75">
              <p className="text-xs font-bold text-brand-dark/40 uppercase tracking-widest mb-4 text-center sm:text-left" data-id="element-76">
                As featured in / trusted by
              </p>
              <div className="flex flex-wrap items-center justify-center sm:justify-start gap-6 sm:gap-10 opacity-40 grayscale" data-id="element-77">
                <span className="font-serif font-bold text-xl" data-id="element-78">Forbes</span>
                <span className="font-serif font-bold text-xl" data-id="element-79">Bloomberg</span>
                <span className="font-sans font-black text-xl tracking-tighter" data-id="element-80">
                  FAST COMPANY
                </span>
                <span className="font-serif font-bold text-xl italic" data-id="element-81">
                  Inc.
                </span>
                <span className="font-serif font-bold text-xl" data-id="element-82">WSJ</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex justify-center lg:justify-end" data-id="element-83">
            <EbookMockup data-id="element-84" />
          </motion.div>
        </div>
      </div>
    </section>;
};